import Vue from 'vue';
// import VueAnalytics from 'vue-analytics';
import AWS from 'aws-sdk';
// import { library } from '@fortawesome/fontawesome-svg-core';
// import {
//   faThumbsUp, faThumbsDown, faCommentAlt,
//   faBookmark, faShareSquare,
// } from '@fortawesome/free-regular-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import router from './router';
import './assets/tailwind.css';

AWS.config.region = 'us-east-1';


// library.add(faThumbsUp, faThumbsDown, faCommentAlt, faBookmark, faShareSquare);
// Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// Vue.use(VueAnalytics, {
//   id: ['UA-99650604-2', 'UA-99650604-1'],
//   router,
// });

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
